import React from 'react';
import { Spin } from 'antd';

export function Spinner() {
  return (
    <div className="w-full h-full px-5 flex justify-center items-center">
      <Spin />
    </div>
  );
}
